import React from 'react';
import { ErrorBoundaryContainer } from '@save/styleguide';
import { ErrorHeader } from './components/header-links.component';

export default function ErrorBoundary(error, info, props) {
  return (
    <ErrorBoundaryContainer applicationName={props.name} error={error}>
      <ErrorHeader />
    </ErrorBoundaryContainer>
  );
}
